import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiResponse } from "../models/api-response.interface";
import { Policy } from "../models/policy.interface";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class PolicyApiService {
  private apiUrl = environment.apiURL;
  private apiV = environment.version;
  constructor(private http: HttpClient) {}

  // GET 
  getAllPolicies(): Observable<ApiResponse<Policy[]>> {
    return this.http.get<ApiResponse<Policy[]>>(
      `${this.apiUrl}/api/${this.apiV}/UserPrivacy`
    );
  }

  // GET KEY
  getPolicyByKey(key: string): Observable<ApiResponse<Policy>> {
    return this.http.get<ApiResponse<Policy>>(
      `${this.apiUrl}/api/${this.apiV}/UserPrivacy/${key}`
    );
  }

  // GET ID
  getPolicyById(id: string): Observable<ApiResponse<Policy>> {
    return this.http.get<ApiResponse<Policy>>(
      `${this.apiUrl}/api/${this.apiV}/UserPrivacy/detail/${id}`
    );
  }
}